<template>
  <div v-if="this.$store.state.server">
    <p class="error">{{ error }}</p>
    <b-form-group label="สินค้า">
      <b-form-radio-group v-model="selected">
        <!-- <b-form-radio v-model="selected" value="goods8">8 บาท</b-form-radio> -->
        <!-- <b-form-radio v-model="selected" value="goods10">10 บาท</b-form-radio> -->
        <!-- <b-form-radio v-model="selected" value="goods13">13 บาท</b-form-radio> -->
        <!-- <b-form-radio v-model="selected" value="goods15">15 บาท</b-form-radio> -->
        <!-- <b-form-radio v-model="selected" value="goods20">20 บาท</b-form-radio> -->
        <b-form-radio v-model="selected" value="goodsother">
          อื่นๆ
          <b-form-input v-show="selected=='goodsother'" v-model="price" type="number"></b-form-input>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <b-row>
      <b-col>QR :</b-col>
      <b-col>
        <b>{{ result }}</b>
      </b-col>
    </b-row>
    <!-- {{test}} -->
    <!-- <b-row>
      <b-col>
        <b-form-input id="name-input" v-model="test" class="text-left"></b-form-input>
      </b-col>
      <b-col>
        <b-button variant="outline-primary" @click="postlogin2()">test</b-button>
      </b-col>
    </b-row> -->
    <!-- <b-row>
      <b-col>QR :</b-col>
      <b-col>
        <b>{{ result }}</b>
      </b-col>
    </b-row> -->
    {{test}}
    <!-- <b-button variant="outline-primary" @click="postgoods('001')">test</b-button> -->
    <qrcode-stream @decode="onDecode" @init="onInit" />
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  components: { QrcodeStream },

  data() {
    return {
      selected: "goodsother",
      result: "",
      error: "",
      test: "",
      price: 0
    };
  },

  methods: {
    onDecode(result) {
      if (result == "") return;
      this.result = result;
      this.postgoods(result);
    },
    postgoods(qr) {
      const formData = new FormData();
      formData.append("api", this.selected);
      formData.append("qr", qr);
      if (this.selected == "goodsother") {
        formData.append("price", this.price);
      }
      axios
        .post(this.$store.state.api, formData)
        .then(response => {
          this.$parent.showAlert(response.data.data, "success");
          this.$router.replace({
            name: "home"
          });
        })
        .catch(e => {});
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    }
  }
};
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
</style>